import React, { useEffect, useRef, useState } from "react";
import performRequest from "../../../api/request";
import { useParams } from "react-router";
import { DateTime } from "luxon";
const today = new Date().getDay();

let messageTime = "19:30:00"; // default

if (today === 5) {
  messageTime = "07:30:00 PM";
} else if (today === 6) {
  messageTime = "11:30:00 AM";
} else if (today === 0) {
  messageTime = "02:00:00 PM";
}
const WebinarChat = () => {
  const [typing, setTyping] = useState(false);
  const chatMessagesRef = useRef(null);
  const chatRef = useRef(null);
  const { id } = useParams();

  const intervalId = useRef(null);
  const countRemovedReq = useRef(0);
  const [chatMessages, setChatMessages] = useState([
    {
      username: "Vishvas from Kryzen",
      text: "Hello everyone! Feel free to ask your questions here.",
      from: "admin",
      time: messageTime,
    },
  ]);
  const [userQuestion, setUserQuestion] = useState("");
  const [gptAnswer, setGptAnswer] = useState("");
  const [newMessage, setNewMessage] = useState("");

  useEffect(() => {
    if (userQuestion && gptAnswer) {
      const data = { userQuestion, gptAnswer };

      console.log(data);
      performRequest("POST", `/webinar/webinar-user-chat/${id}`, data)
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setUserQuestion("");
          setGptAnswer("");
        });
    }
  }, [userQuestion, gptAnswer]);

  // Chat functionality
  async function askToOpenAI(question) {
    try {
      const res = await performRequest(
        "POST",
        `/webinar/webinar-chat_with_openai/`,
        {
          inputText: question,
        }
      );
      const answer = res?.data?.outputText || "";
      console.log("Returned Answer:", answer);
      return answer;
    } catch (err) {
      console.error(err);
      return "";
    }
  }

  const getAdminReply = (message) => {
    if (intervalId.current) {
      clearTimeout(intervalId.current);
      countRemovedReq.current++;
    }
    setTyping(true);
    const delay =
      Math.floor(Math.random() * (1000 * 60 - 200 * 60 + 1)) + 200 * 60;
    intervalId.current = setTimeout(() => {
      let newMessageText = "";
      if (countRemovedReq.current > 0) {
        const prevChat = chatMessages?.filter((el) => el.from === "user");
        if (prevChat.length >= countRemovedReq.current) {
          for (
            let i = prevChat.length - countRemovedReq.current;
            i < prevChat.length;
            i++
          ) {
            newMessageText += prevChat[i].text + " ";
          }
        }
      }
      newMessageText = newMessageText + message;
      setUserQuestion(() => newMessageText);
      askToOpenAI(newMessageText)
        .then((res) => {
          if (res) {
            setGptAnswer((prev) => res);
            setChatMessages([
              ...chatRef.current,
              {
                username: "Vishvas from Kryzen",
                text: res,
                from: "admin",
                time: DateTime.now()
                  .setZone("Asia/Kolkata")
                  .toFormat("hh:mm:ss a"),
              },
            ]);
          }
        })
        .finally(() => {
          intervalId.current = null;
          countRemovedReq.current = 0;
          setTyping(false);
        });
    }, delay);
  };
  const sendMessage = () => {
    if (newMessage.trim() !== "") {
      setChatMessages([
        ...chatMessages,
        {
          username: "You",
          text: newMessage,
          from: "user",
          time: DateTime.now().setZone("Asia/Kolkata").toFormat("hh:mm:ss a"),
        },
      ]);
      getAdminReply(newMessage.trim());
      setNewMessage("");
    }
  };

  useEffect(() => {
    if (chatMessages) {
      chatRef.current = chatMessages;
    }
  }, [chatMessages]);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [chatMessages, typing]);
  const renderMessage = (text) => {
    if (!text) {
      return "";
    }
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };
  return (
    <div className="col-12 mt-3">
      <div className="card bg-light d-flex flex-column px-lg-8">
        <div
          ref={chatMessagesRef}
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
          }}
          className="card-body overflow-auto"
        >
          <div className="chat">
            <div className="chat-bubbles">
              {chatMessages?.map((message, index) => (
                <div key={index} className="chat-item">
                  {message.from === "admin" ? (
                    <div className="row align-items-end">
                      <div className="col col-lg-7">
                        <div className="chat-bubble bg-secondary-lt">
                          <div className="chat-bubble-title">
                            <div className="row">
                              <div className="col chat-bubble-author">
                                {message.username?.toUpperCase()}
                              </div>
                              <div className="col-auto chat-bubble-date">
                                {message.time}
                              </div>
                            </div>
                          </div>
                          <div className="chat-bubble-body">
                            <p>{renderMessage(message.text)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row align-items-end justify-content-end">
                      <div className="col col-lg-7">
                        <div className="chat-bubble chat-bubble-me">
                          <div className="chat-bubble-title">
                            <div className="row">
                              <div className="col chat-bubble-author">
                                {message.username?.toUpperCase()}
                              </div>
                              <div className="col-auto chat-bubble-date">
                                {message.time}
                              </div>
                            </div>
                          </div>
                          <div className="chat-bubble-body">
                            <p>{message.text}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {typing && (
                <div className="typing">
                  Typing<span className="dots"></span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="chat-input d-flex p-2">
          <input
            type="text"
            className="form-control me-2"
            placeholder="Ask questions..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            onFocus={() =>
              (chatMessagesRef.current.scrollTop =
                chatMessagesRef.current.scrollHeight)
            }
            aria-label="Chat input"
          />
          <button className="btn btn-primary" onClick={sendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebinarChat;
